export default __webpack_public_path__ + "static/media/dreamscape_poster.cd1468f5.jpg";